export enum ExcelCurrency {
    USD = 'usd',
    EUR = 'eur',
    HND = 'hnd',
}
